import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/home/img_diningPart_profileList.png")